module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_magnifier-0d66de78f3ceb86a65a7df230b33caff.svg";